import { getPreloadResult } from './PreloadResult';

export const preloadedRestLink = async (
	url: string,
	{
		method,
		headers,
		claimKey,
	}: {
		method: string;
		headers?: HeadersInit;
		claimKey?: string;
	},
	passThrough: () => Promise<any>,
) => {
	if (!method || method.toUpperCase() !== 'GET') {
		return passThrough();
	}

	return getPreloadResult()
		.claim(
			claimKey ? { name: claimKey } : { name: url, variables: { method, ...headers } },
			(result) => {
				return result;
			},
		)
		.then((data) => {
			if (!data) {
				return passThrough();
			}
			return data;
		});
};
